import { z } from 'zod';
import { DeviceKind } from '../shared/device-kind.js';
export const AuthDeviceType = DeviceKind;
export const AuthDeviceSummary = z.object({
    deviceType: AuthDeviceType,
    browser: z.string().nullable(),
    os: z.string().nullable(),
});
//# sourceMappingURL=device.js.map